import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: resolve => require(['@/views/Index.vue'], resolve),    //首页
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login.vue'], resolve),      //登录
  },
  {
    path: '/phonelogin',
    name: 'phonelogin',
    component: resolve => require(['@/views/phonelogin.vue'], resolve),     //验证码登录
  },
  {
    path: '/ThinkTank',
    name: 'ThinkTank',
    component: resolve => require(['@/views/ThinkTank.vue'], resolve),     //智库页面
  },
  {
    path: '/Abouts',
    name: 'Abouts',
    component: resolve => require(['@/views/Abouts.vue'], resolve),     //关于页面
  },
  {
    path: '/Scientific',
    name: 'Scientific',
    component: resolve => require(['@/views/Scientific.vue'], resolve),     //科研资讯
  },
  {
    path: '/Research',
    name: 'Research',
    component: resolve => require(['@/views/Research.vue'], resolve),     //研究报告
  },
  {
        path: "/Searchpant",
        name: "Searchpant",
        component: (resolve) => require(["@/views/Searchpant.vue"], resolve), //搜索专利页面
      },
      {
        path: "/Searchreport",
        name: "Searchreport",
        component: (resolve) => require(["@/views/Searchreport.vue"], resolve), //搜索研报页面
      },
      {
        path: "/Searchrefer",
        name: "Searchrefer",
        component: (resolve) => require(["@/views/Searchrefer.vue"], resolve), //搜索资讯页面
      },
  {
    path: '/PatentTransfer',
    name: 'PatentTransfer',
    component: resolve => require(['@/views/PatentTransfer.vue'], resolve),     //专利转让
  },
  {
    path: '/AuthorsHome',
    name: 'AuthorsHome',
    component: resolve => require(['@/views/AuthorsHome.vue'], resolve),     //作者首页页面
  },
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    component: resolve => require(['@/views/PersonalCenter.vue'], resolve),     //个人中心
    redirect: "/PersonalCenter/index",
    // 二级路由
    children: [
      {
        path: 'index',
        component: resolve => require(['@/components/PersonalChildren/index'], resolve),
      },    //个人中心首页
      {
        path: 'DataAnalysis',
        component: resolve => require(['@/components/PersonalChildren/DataAnalysis'], resolve),
      },    //数据分析
      {
        path: 'DataAny',
        component: resolve => require(['@/components/PersonalChildren/DataAny'], resolve),
      },    //指数分析DataAnyFen
      {
        path: 'DataAnyFen',
        component: resolve => require(['@/components/PersonalChildren/DataAnyFen'], resolve),
      },    //粉丝分析
      {
        path: 'Releases',
        component: resolve => require(['@/components/PersonalChildren/Releases'], resolve),
      },    //我的发布
      {
        path: 'ReleaseInformation',
        component: resolve => require(['@/components/PersonalChildren/ReleaseInformation'], resolve),
      },    //发布资讯
      {
        path: 'ResetPwd',
        component: resolve => require(['@/components/PersonalChildren/ResetPwd'], resolve),
      },    //修改密码
      {
        path: 'Dds',
        component: resolve => require(['@/components/PersonalChildren/Dds'], resolve),
      },    //账号信用
      {
        path: 'AccountSeetings',
        component: resolve => require(['@/components/PersonalChildren/AccountSeetings'], resolve),
      },    //账号设置
      {
        path: 'CommentsManage',
        component: resolve => require(['@/components/PersonalChildren/CommentsManage'], resolve),
      },    //评论管理
      {
        path: 'Patent',
        component: resolve => require(['@/components/PersonalChildren/Patent'], resolve),
      },    //发布专利
      {
        path: 'ResearchReport',
        component: resolve => require(['@/components/PersonalChildren/ResearchReport'], resolve),
      },    //发布研报
      {
        path: 'conPerson',
        component: resolve => require(['@/components/PersonalChildren/conPerson'], resolve),
      },    //粉丝管理
    ]
  },
  {
    path: '/IdAuthentication',
    name: 'IdAuthentication',
    component: resolve => require(['@/views/IdAuthentication.vue'], resolve),     //身份认证页面
  },
  {
    path: '/ExpertCertification',
    name: 'ExpertCertification',
    component: resolve => require(['@/views/ExpertCertification.vue'], resolve),     //专家认证信息页面
  },
  {
    path: '/AgencyCertification',
    name: 'AgencyCertification',
    component: resolve => require(['@/views/AgencyCertification.vue'], resolve),     //机构认证信息页面
  },
  {
    path: '/PatentDetails',
    name: 'PatentDetails',
    component: resolve => require(['@/views/PatentDetails.vue'], resolve),     //专利详情页面
  },
  {
    path: '/InformationDetails',
    name: 'InformationDetails',
    component: resolve => require(['@/views/InformationDetails.vue'], resolve),     //资讯详情
  },
  {
    path: '/ResearchReportDetails',
    name: 'ResearchReportDetails',
    component: resolve => require(['@/views/ResearchReportDetails.vue'], resolve),     //研报详情页面
  }, 
  {
    path: '/RZAgencyCertification',
    name: 'RZAgencyCertification',
    component: resolve => require(['@/views/RZAgencyCertification.vue'], resolve),     //查看认证过的机构页面
  },   
  {
    path: '/RZExpertCertification',
    name: 'RZExpertCertification',
    component: resolve => require(['@/views/RZExpertCertification.vue'], resolve),     //查看认证过的专家页面
  },  
  {
    path: '/Notice',
    name: 'Notice',
    component: resolve => require(['@/views/Notice.vue'], resolve),     //公告
  },  
  {
    path: '/NoticeDetails',
    name: 'NoticeDetails',
    component: resolve => require(['@/views/NoticeDetails.vue'], resolve),     //公告详情
  }, 
  {
    path: "/404",
    name: "404",
    component: resolve => require(['@/views/404.vue'], resolve),
    },
    {
    path: "*", // 此处需特别注意置于最底部
    redirect: "/404"
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
